import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'gatsby'

const StyledBreadcrumbs = styled.div`
  color: #4e5d78;
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: -16px;
`

const StyledLink = styled(Link)`
  color: #8a94a6;

  ${({ current }) =>
    current &&
    css`
      color: #4e5d78;
      max-width: 139px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      ${({ theme }) => theme.media.desktop} {
        max-width: 76%;
      }
    `}
`

const StyledSlash = styled.span`
  display: block;
  margin: 0 8px;
`

const Breadcrumbs = ({ items }) => (
  <StyledBreadcrumbs>
    {items.map((item, index) =>
      index < items.length - 1 ? (
        <React.Fragment key={index}>
          <StyledLink to={item.path}>{item.name}</StyledLink>{' '}
          <StyledSlash>/</StyledSlash>
        </React.Fragment>
      ) : (
        <span key="last-crumb">{item.name}</span>
      )
    )}
  </StyledBreadcrumbs>
)

export default Breadcrumbs
